import React from 'react';
import { Button } from '../../Atoms';

import ResourceImage from '../../Assets/images/resources.png';

const Solutions = ({ isClevel }) => {
  return (
    <div className="resources">
      <h4>Resources</h4>
      <div className="resource-wrapper">
        {isClevel && <img src={ResourceImage} alt="resource" />}
        <div>
          <div className="resource-wrap">
            <p>
              Check out some helpful tips on how to be more calm with{' '}
              <b>Mindful May Challenge.</b>
            </p>
            <Button size="md" color="white">
              CHECK IT OUT
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
